export function OutlineListIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6 11.9992C6.6 11.0051 5.79411 10.1992 4.8 10.1992C3.80589 10.1992 3 11.0051 3 11.9992C3 12.9933 3.80589 13.7992 4.8 13.7992C5.79411 13.7992 6.6 12.9933 6.6 11.9992Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2049 10.1992H11.7937C10.8023 10.1992 9.99854 11.003 9.99854 11.9944V12.004C9.99854 12.9955 10.8023 13.7992 11.7937 13.7992H19.2049C20.1964 13.7992 21.0001 12.9955 21.0001 12.004V11.9944C21.0001 11.003 20.1964 10.1992 19.2049 10.1992Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6 4.8C6.6 3.80589 5.79411 3 4.8 3C3.80589 3 3 3.80589 3 4.8C3 5.79411 3.80589 6.6 4.8 6.6C5.79411 6.6 6.6 5.79411 6.6 4.8Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2049 3H11.7937C10.8023 3 9.99854 3.80374 9.99854 4.7952V4.8048C9.99854 5.79626 10.8023 6.6 11.7937 6.6H19.2049C20.1964 6.6 21.0001 5.79626 21.0001 4.8048V4.7952C21.0001 3.80374 20.1964 3 19.2049 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6 19.2004C6.6 18.2063 5.79411 17.4004 4.8 17.4004C3.80589 17.4004 3 18.2063 3 19.2004C3 20.1945 3.80589 21.0004 4.8 21.0004C5.79411 21.0004 6.6 20.1945 6.6 19.2004Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2049 17.4004H11.7937C10.8023 17.4004 9.99854 18.2041 9.99854 19.1956V19.2052C9.99854 20.1967 10.8023 21.0004 11.7937 21.0004H19.2049C20.1964 21.0004 21.0001 20.1967 21.0001 19.2052V19.1956C21.0001 18.2041 20.1964 17.4004 19.2049 17.4004Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
